export class ApiError extends Error {
  constructor(status, body, message) {
    super(message || `API error: ${status}`);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
    this.isRetryable = status >= 500 || status === 408 || status === 429;
  }
}

export function isNetworkError(error) {
  return error instanceof TypeError && error.message === 'Failed to fetch';
}

export function isAuthError(error) {
  return error instanceof ApiError && error.status === 401;
}
